import { render, staticRenderFns } from "./RedirectToApp.vue?vue&type=template&id=166a95ec"
import script from "./RedirectToApp.vue?vue&type=script&lang=ts"
export * from "./RedirectToApp.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports